
export default class Topic {

    id!: number;
    name!: string;
    description!: string;
    write!: boolean;

    public static fromResponse(data: any): Topic {

        const result: Topic = new Topic();

        if (data.id != undefined) {
            result.id = data.id;
        }

        if (data.name != undefined) {
            result.name = data.name;
        }

        if (data.description != undefined) {
            result.description = data.description;
        }

        if (data.write != undefined) {
            result.write = data.write;
        }

        return result;

    }

}